// extracted by mini-css-extract-plugin
export default {"category__card":"categorie-card_category__card__o+kng","category__title":"categorie-card_category__title__-eKpM","category__value":"categorie-card_category__value__RDYo5"};